webpackJsonp([3],{

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "PropertiesModal",
  props: ['htmlCode', 'isHtmlEdit', 'htmlKeysListFiltered', 'title'],
  data: function data() {
    return {
      listItems: [],
      formData: {
        name: '',
        value: ''
      },
      err: ''
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    getFormData: function getFormData(files) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          resolve(null);
        };
      });
    },
    startInput: function startInput(name) {
      this.$refs[name].click();
    },
    onFileChange: function onFileChange(name, $event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var files, data, maxSize, img;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = $event.target.files || $event.dataTransfer.files;

                if (!(files && files[0])) {
                  _context.next = 18;
                  break;
                }

                _context.next = 4;
                return _this2.getFormData(files);

              case 4:
                data = _context.sent;

                if (!(data === null)) {
                  _context.next = 8;
                  break;
                }

                _this2.err = 'Failed to convert image';
                return _context.abrupt('return');

              case 8:
                maxSize = 786432;

                if (!(files[0].size > maxSize)) {
                  _context.next = 13;
                  break;
                }

                _this2.err = 'The selected images is beyond limit of ' + maxSize + ' KB.';
                _this2.formData.value = '';
                return _context.abrupt('return');

              case 13:
                img = new Image();

                img.src = window.URL.createObjectURL(files[0]);
                img.onload = function () {
                  window.URL.revokeObjectURL(img.src);
                  _this2.formData.value = data;
                };
                _context.next = 19;
                break;

              case 18:
                _this2.formData.value = '';

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    submitHtmlCode: function submitHtmlCode() {
      if (this.formData.name === '') {
        this.err = 'You must select Position/Name!';
        return;
      }
      if (this.formData.value === '') {
        this.err = 'Value cannot be empty!';
        return;
      }
      this.$emit('submit', this.formData);
    }
  },
  created: function created() {
    this.listItems = this.htmlKeysListFiltered;
    if (this.htmlCode) {
      this.formData = this.htmlCode;
      this.listItems = [this.htmlCode.name];
    }
  }
});

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PropertiesModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("e8c2105a", content, true, {});

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Position/Name",
      "items": _vm.listItems,
      "hide-details": ""
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pl-2": ""
    }
  }, [(['desktop.image', 'tablet.image'].includes(_vm.formData.name)) ? _c('v-text-field', {
    ref: "fileTextField",
    staticClass: "min-w",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "hide-details": "",
      "label": "Choose Image",
      "required": ""
    },
    on: {
      "click": function($event) {
        return _vm.startInput('imageInput')
      }
    },
    model: {
      value: (_vm.formData.value),
      callback: function($$v) {
        _vm.$set(_vm.formData, "value", $$v)
      },
      expression: "formData.value"
    }
  }) : _vm._e(), _vm._v(" "), (['desktop.image', 'tablet.image'].includes(_vm.formData.name)) ? _c('input', {
    ref: "imageInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange('imageInput', $event)
      }
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Selected coordinate value",
      "type": "number"
    },
    model: {
      value: (_vm.formData.value),
      callback: function($$v) {
        _vm.$set(_vm.formData, "value", $$v)
      },
      expression: "formData.value"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitHtmlCode()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b824bfc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.cad760cafcf59aff2eaa.js